import React from 'react'
import {Modal, Button, Spinner} from 'react-bootstrap'
import {useI18n} from '../../../../../Utils/_helpers/useI18n'

interface CancelInstanceModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isCancelling: boolean
}

const CancelInstanceModal: React.FC<CancelInstanceModalProps> = ({
  show,
  onHide,
  onConfirm,
  isCancelling,
}) => {
  const {t} = useI18n()
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className='fs-5 text-danger'>
          <i className='bi bi-x-circle me-2'></i>
          {t('FLOW.INSTANCE.CANCEL_INSTANCE')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex flex-column gap-3'>
          <div className='d-flex align-items-center gap-2'>
            <i className='bi bi-exclamation-triangle text-danger'></i>
            <span>{t('FLOW.INSTANCE.CANCEL_JOB_SUCCESS')}</span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <i className='bi bi-x-circle text-danger'></i>
            <span>{t('FLOW.INSTANCE.CANCEL_JOB_SUCCESS_DESC')}</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onHide}>
          {t('COMMON.ACTIONS.CANCEL')}
        </Button>
        <Button variant='danger' onClick={onConfirm} disabled={isCancelling}>
          {isCancelling ? (
            <>
              <Spinner animation='border' size='sm' className='me-2' />
              {t('FLOW.INSTANCE.CANCEL_JOB_SUCCESS')}
            </>
          ) : (
            t('FLOW.INSTANCE.CANCEL_INSTANCE')
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CancelInstanceModal
